<template>
	<div class="goods">
		<van-swipe v-if="order.cover" class="goods-swipe" :autoplay="3000">
			<van-swipe-item>
				<img :src="order.cover" />
			</van-swipe-item>
		</van-swipe>

		<van-row>
			<van-col offset="6" span="12">
				<div class="book-name">物品名称:{{ order.goodsname }}</div>
			</van-col>
		</van-row>
		<van-row>
			<van-col offset="6" span="12">
				<div class="book-name">SN:{{ order.sn }}</div>
			</van-col>
		</van-row>
		<van-row>
			<van-col offset="6" span="12">
				<div class="book-author">学校名称:&nbsp;{{ order.schoolName }}</div>
			</van-col>
		</van-row>
		<van-row>
			<van-col offset="6" span="12">
				<div class="book-publisher">所属集团:&nbsp;{{ order.companyName }}</div>
			</van-col>
		</van-row>

		<van-divider />

		<van-goods-action>
			<van-goods-action-button
				v-if="takeOrders == 0 && takeOrders != 255"
				type="danger"
				@click="borrow"
			>
				立即借出
			</van-goods-action-button>
			<van-goods-action-button
				v-if="takeOrders != 0 && takeOrders != 255"
				type="primary"
				@click="returnNow"
			>
				立即归还
			</van-goods-action-button>
		</van-goods-action>
	</div>
</template>

<script>
import {
	Tag,
	Col,
	Icon,
	Cell,
	CellGroup,
	Swipe,
	Toast,
	SwipeItem,
	GoodsAction,
	GoodsActionIcon,
	GoodsActionButton,
	Rate,
	Row,
	Divider,
	Popup,
	Dialog,
} from "vant";

import { Get, Post } from "@/utils/Api";

export default {
	components: {
		[Tag.name]: Tag,
		[Col.name]: Col,
		[Icon.name]: Icon,
		[Cell.name]: Cell,
		[CellGroup.name]: CellGroup,
		[Swipe.name]: Swipe,
		[SwipeItem.name]: SwipeItem,
		[GoodsAction.name]: GoodsAction,
		[GoodsActionIcon.name]: GoodsActionIcon,
		[GoodsActionButton.name]: GoodsActionButton,
		[Rate.name]: Rate,
		[Row.name]: Row,
		[Divider.name]: Divider,
		[Popup.name]: Popup,
		[Dialog.Component.name]: Dialog.Component,
	},
	data() {
		return {
			orderId: null,
			order: {},
			takeOrders: 255,
		};
	},
	mounted: function() {
		console.log("mounted");
		this.orderId = this.$route.params.id;
		console.log(" orderId ", this.orderId);

		//获取物品详情
		this.getGoodsDetail();

		//判断是否有未归还的订单
		this.getGoodsOrders();
	},

	methods: {
		getGoodsOrders() {
			var openId = localStorage.getItem("openId");

			Post(
				"goods/queryGoodsOrder",
				{
					goodDetailId: this.orderId,
					openId: openId,
				},
				(res) => {
					console.log("order detail", res.data.data);
					var r = res.data;

					if (r.success) {
						this.takeOrders = r.data.length;
					}
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		},
		getGoodsDetail() {
			Get(
				"goods/queryDetail",
				{
					id: this.orderId,
				},
				(res) => {
					console.log("order detail", res.data.data);
					var r = res.data;
					this.order = {};
					if (r.success && r.data.length > 0) {
						this.order = r.data[0];
					}
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		},
		borrow() {
			Dialog.confirm({
				title: "消息确认",
				message: "确认要借出 [" + this.order.goodsname + "] 吗?",
			})
				.then(() => {
					// on confirm
					var openId = localStorage.getItem("openId");
					Post(
						"goods/borrow",
						{
							id: this.orderId,
							openId: openId,
						},
						(res) => {
							var result = res.data;

							console.log("goods borrow", result);
							if (result.success) {
								Toast.success("借出成功");
								this.getGoodsOrders();
							} else {
								Toast.fail(result.msg);
							}
						},
						(res) => {
							console.log("ERROR", res);
						}
					);
				})
				.catch(() => {
					// on cancel
				});
		},
		returnNow() {
			Dialog.confirm({
				title: "消息确认",
				message: "确认要归还 [" + this.order.goodsname + "] 吗?",
			})
				.then(() => {
					// on confirm
					var openId = localStorage.getItem("openId");
					Post(
						"goods/returnNow",
						{
							id: this.orderId,
							openId: openId,
						},
						(res) => {
							var result = res.data;

							console.log("goods return", result);
							if (result.success) {
								Toast.success("归还成功");
								this.getGoodsOrders();
							} else {
								Toast.fail(result.msg);
							}
						},
						(res) => {
							console.log("ERROR", res);
						}
					);
				})
				.catch(() => {
					// on cancel
				});
		},
	},
};
</script>

<style lang="less">
.book-name {
	font-size: 20px;
	font-weight: bolder;
	text-align: center;
	margin: 10px 0 10px 0;
}

.book-author {
	color: #8888ff;
	text-align: center;
}

.book-publisher {
	text-align: center;
}

.book-rate {
	font-size: 20px;
	margin-right: 10px;
}

.book-times {
	font-size: 12px;
	text-align: center;
	color: #888888;
	margin: 10px 0 10px 0;
}

.book-borrow-times {
	margin-right: 20px;
}

.book-tag {
	margin-left: 10px;
	padding: 5px 10px 5px 10px;
}

.book-code,
.book-code-title,
.book-tip {
	margin: 10px;
	text-align: center;
}

.book-code {
	font-size: 30px;
	font-weight: bolder;
}

.book-code-title {
	font-size: 20px;
	font-weight: bolder;
}

.book-tip {
	color: #888888;
}

.goods {
	padding-bottom: 50px;

	background-color: #ffffff;

	&-swipe {
		img {
			width: 100%;
			display: block;
		}
	}

	&-title {
		font-size: 16px;
	}

	&-price {
		color: #f44;
	}

	&-express {
		color: #999;
		font-size: 12px;
		padding: 5px 15px;
	}

	&-cell-group {
		margin: 15px 0;

		.van-cell__value {
			color: #999;
		}
	}

	&-tag {
		margin-left: 5px;
	}
}
</style>
